import * as _4 from 'lodash4';
import { ISection } from '../../interfaces/scheduler_interfaces';
import { MeetingTimeServant } from '../meeting_times/servants/meeting_time_servant';
export class SectionTimeLengthController {
  private timeDiffTitle: string = '';
  private theme: string;
  private section: ISection;

  constructor(private ngMeetingTimeServant: MeetingTimeServant) {}
  init() {
    this.theme = this.theme || `gray-dark`;
    this.timeDiffTitle = this.ngMeetingTimeServant.dateDifferenceInWeeksOrDays(
      _4.get(this.section, 'class_start_dt', ''),
      _4.get(this.section, 'class_end_dt', '')
    );
  }
  $onChanges() {
    this.init();
  }
}

angular.module('capability-ng-scheduler').component('sectionTimeLength', {
  templateUrl: 'capability-ng-scheduler/src/components/section_time_length/section_time_length.html',
  controller: SectionTimeLengthController,
  bindings: {
    theme: '@',
    section: '<',
    badgeClass: '@'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_time_length/section_time_length.ts